@if (event){
    <div class="relative my-3 border-slate-200 dark:border-slate-500 border bg-slate-100 dark:bg-slate-700 text-lrpTicketBlack dark:text-stone-300 rounded-xl p-4 shadow-md" [class.cancelled]="event.cancelled" [class.complete]="eventPassed">
        <div class="flex px-4 gap-5 lg:mr-40 w-full z-50">
            @if (event.image) {
                <div class="min-w-20 min-h-20 max-h-20 max-w-20 bg-center bg-cover rounded-xl shadow-md bg-white shadow-lrpTicketBlack transition-transform ease-in-out duration-500" style="background-image: url('{{ event.image.url}}');">
                    @if (event.eventHost.img) {
                        <img [src]="event.eventHost.img.url" class="w-10 my-1 mx-1 mix-blend-multiply hover:w-16 hover:mt-3 hover:ms-2" [alt]="event.eventHost.name">
                    }
                </div>
            }
            @else {
                <div class="min-w-20 min-h-20 max-h-20 max-w-20 p-4 rounded-xl shadow-md bg-white shadow-lrpTicketBlack">
                    @if (event.eventHost.img) {
                        <img [src]="event.eventHost.img.url" class="mix-blend-multiply" [alt]="event.eventHost.name">
                    }
                </div>
            }
            <div class="w-full h-full">
                <div class="flex justify-between">
                    <h2>{{event.eventHost.eventSystem.name }} {{ event.eventHost.display ? ' - ' + event.eventHost.name + ' ' : '' }} | {{ event.name }}</h2>
                    @if (event.eventHost.eventSystem.img) {
                        <a [routerLink]="'/system/' + event.eventHost.eventSystem.systemRef"><img class="max-h-14 -mt-3" [src]="event.eventHost.eventSystem.img.url" alt=""></a>
                    }
                </div>
                <p class=" text-gray-400 -mt-3" i18n>
                    @if (event.eventStart == event.eventEnd) {
                        {{ event.eventStart | date:'shortDate' : 'en-GB'}}
                    }
                    @else if (event.eventStart != event.eventEnd) {
                        {{ event.eventStart | date:'shortDate' : 'en-GB'}} - {{ event.eventEnd | date:'shortDate' : 'en-GB'}}
                    }
                </p>
                <p class="text-md text-gray-400 -mt-1" i18n>
                    <a href="https://www.google.com/maps/search/?api=1&query={{ event.location }}">{{ event.location.split(',')[0] }}</a>
                </p>
            </div>
        </div>
        <div class="flex gap-6 mt-4">
            @if (event.visible) {
                <div class="border border-green-300 rounded-3xl px-6 text-green-500 font-semibold bg-green-300/40 text-sm">
                    Advertised
                </div>
            } @else {
                <div class="border border-gray-300 rounded-3xl px-6 text-lrpTicketBlack/60 font-semibold bg-gray-100 text-sm">
                    Not advertised
                </div>
            }
            @if (event.allowBookings) {
                <div class="border border-green-300 rounded-3xl px-6 text-green-500 font-semibold bg-green-300/40 text-sm">
                    Open for booking
                </div>
            } @else {
                <div class="border border-gray-300 rounded-3xl px-6 text-lrpTicketBlack/60 font-semibold bg-gray-100 text-sm">
                    Closed for booking
                </div>
            }            
        </div>
        <div class="grid grid-cols-3 gap-1 w-full py-2 mt-0 text-center">
            <div class="flex flex-col gap-3 w-full pt-2">
                <app-progress-bar [value]="(event.eventsLimits)?.playerBookings ?? 0" [max]="(event.eventsLimits)?.playerLimit ?? 50" label="players" [title]="(event.eventsLimits)?.playerLimit ? 'Player Limit' : 'Player Limit Not Set'" />
                <app-progress-bar [value]="(event.eventsLimits)?.crewBookings ?? 0" [max]="(event.eventsLimits)?.crewLimit ?? 30" label="crew" [title]="(event.eventsLimits)?.crewLimit ? 'Crew Limit' : 'Crew Limit Not Set'" />
                <app-progress-bar [value]="(event.eventsLimits)?.staffBookings ?? 0" [max]="(event.eventsLimits)?.staffLimit ?? 10" label="staff" [title]="(event.eventsLimits)?.staffLimit ? 'Staff Limit' : 'Staff Limit Not Set'" />
            </div>
            <table class="">
                <tr class="h-0">
                    <td class="text-end">{{ event.eventsFinancials?.bookingsPending ?? 0 }} </td>
                    <td class="text-start ps-2">Bookings Pending</td>
                </tr>
                <tr class="h-0">
                    <td class="text-end text-green-600">{{ event.eventsFinancials?.totalPaid ?? 0 | currency:'GBP' }} </td>
                    <td class="text-start ps-2">Total Paid</td>
                </tr>
                <tr class="h-0">
                    <td class="text-end text-red-600">{{ event.eventsFinancials?.totalFees ?? 0 | currency:'GBP' }}</td>
                    <td class="text-start ps-2">Payment Fees</td>
                </tr>
            </table>
            <div class="flex flex-col gap-3 w-full z-10">
                <button class="primaryButton" [routerLink]="'/admin/events/' + event.eventLink">Manage Event</button>
                <button class="outline-button" [routerLink]="'/events/' + event.eventLink" >View Event Page</button>
            </div>
        </div>
    </div>
}